import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

export default function MagneticCursor() {
  const [cursor, setCursor] = useState({ x: -200, y: -200, scale: 1 });

  useEffect(() => {
    const onMove = (event) => {
      const magnetic = event.target.closest('[data-magnetic]');

      if (!magnetic) {
        setCursor({ x: event.clientX, y: event.clientY, scale: 1 });
        return;
      }

      const rect = magnetic.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      const offsetX = (event.clientX - centerX) * 0.2;
      const offsetY = (event.clientY - centerY) * 0.2;

      magnetic.style.transform = `translate3d(${offsetX}px, ${offsetY}px, 0)`;
      setCursor({ x: event.clientX, y: event.clientY, scale: 1.8 });
    };

    const onLeave = () => setCursor((prev) => ({ ...prev, scale: 1 }));

    window.addEventListener('mousemove', onMove, { passive: true });
    window.addEventListener('mouseleave', onLeave);

    return () => {
      document.querySelectorAll('[data-magnetic]').forEach((element) => {
        element.style.transform = 'translate3d(0, 0, 0)';
      });
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseleave', onLeave);
    };
  }, []);

  return (
    <motion.div
      aria-hidden="true"
      className="pointer-events-none fixed left-0 top-0 z-[60] hidden h-8 w-8 -translate-x-1/2 -translate-y-1/2 rounded-full border border-cyan-300/60 bg-cyan-300/20 backdrop-blur md:block"
      animate={{ x: cursor.x, y: cursor.y, scale: cursor.scale }}
      transition={{ type: 'spring', stiffness: 350, damping: 28, mass: 0.4 }}
    />
  );
}
